import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, type OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { SiteState } from '@stores/site';
import { Observable } from 'rxjs';

@Component({
  selector: 'tr-public-template',
  imports: [CommonModule, RouterOutlet],
  templateUrl: './public-template.component.html',
  styleUrl: './public-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicTemplateComponent implements OnInit {
  private store = inject(Store);

  loading$: Observable<boolean> = this.store.select(SiteState.isLoading);

  ngOnInit(): void {}
}
